import styled from 'styled-components';

export const LegendContainer = styled.div`
  color: ${({ theme }) => theme.colors.eerieBlack};
  background-color: unset;
`;

export const LegendList = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  margin: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.s} 0
    0;
`;

export const Swatch = styled.span`
  width: ${({ theme }) => theme.spacing.sm};
  height: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radius.xl};
  margin-right: ${({ theme }) => theme.spacing.s};
  flex-shrink: 0;
`;

export const LegendText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
  color: ${({ theme }) => theme.colors.text};
`;
